import React, { useState } from 'react'
import { Accordion, Button, ListGroup, Offcanvas} from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux';
import { setUserinfo,setMenuClose } from '../../store/modules/logininfo';
import { useNavigate } from 'react-router-dom';
import Repwd from '../Repwd';
//import Retel from '../Retel';
import Languageitem from '../Languageitem';
import Saveitem from '../Saveitem';
import Colorbar from '../Colorbar';
import Exchange from '../Exchange';
import Permission from '../Permission';
import Usernum from '../Usernum';
import Resetpwd from '../Resetpwd';
import Crsytal from '../Crsytal';
import Screening from '../Screening';
import Tikuadd from '../Tikuadd';
import langList from '../../utils/languagelist.json';
import DownloadButton from '../DownloadButton';

export default function Menubar(p) {
  const {usern,role}=useSelector((state)=>state.logininfo);
  const {lg}=useSelector((state)=>state.language);
  const dispatch=useDispatch();

  const { nu:{closeMenubar} }=p
  const isfunction = typeof closeMenubar === 'function';

  const [show, setShow] = useState(true);

  const handleClose = () =>{
    setShow(false);
    isfunction && closeMenubar()
    dispatch(setMenuClose({menu:false}))
  };

  const handleLogout = () =>{
    // 把redux改为初始值
    dispatch(setUserinfo({usern:'',expires:0,role:'',menu:false}))
    // 删除token
    localStorage.removeItem('token');
    // 关闭菜单窗口
    handleClose();
  };

  const navigate=useNavigate();
  const handleToAgree = (str)=>{
    navigate('/agreement',{replace:true,state:{str}});
  }
  
  return (
    <Offcanvas show={show} placement={'end'}  onHide={handleClose}>
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{usern}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Accordion>
          <Accordion.Item eventKey="0">
            <Accordion.Header>{langList.menubar1[lg]}</Accordion.Header>
            <Accordion.Body>
              <Languageitem />
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="1">
            <Accordion.Header>{langList.menubar2[lg]}</Accordion.Header>
            <Accordion.Body>
              <ListGroup variant="flush" className='ps-1'>
                <ListGroup.Item action onClick={handleLogout} className='py-3'>{langList.menubar12[lg]}</ListGroup.Item>
              </ListGroup>
              <hr className='my-0' style={{borderTop: '1px solid Gray'}}/>
              <Accordion flush>
                <Accordion.Item eventKey="11">
                  <Accordion.Header>{langList.menubar13[lg]}</Accordion.Header>
                  <Accordion.Body className='px-0'>
                    <Repwd />
                  </Accordion.Body>
                </Accordion.Item>
                {/* <Accordion.Item eventKey="12">
                  <Accordion.Header>修改电话号</Accordion.Header>
                  <Accordion.Body className='px-0'>
                    <Retel />
                  </Accordion.Body>
                </Accordion.Item> */}
              </Accordion>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="2">
            <Accordion.Header>{langList.menubar3[lg]}</Accordion.Header>
            <Accordion.Body>
              <Saveitem />
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="3">
            <Accordion.Header>{langList.menubar4[lg]}</Accordion.Header>
            <Accordion.Body>
              <Colorbar/>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="4">
            <Accordion.Header>{langList.menubar5[lg]}</Accordion.Header>
            <Accordion.Body className='px-2'>
              <Exchange/>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="5">
            <Accordion.Header>{langList.menubar6[lg]}</Accordion.Header>
            <Accordion.Body>
              <div className='mt-3'>
                <img src='./pic/beian.png' alt='' width={'16px'} height={'16px'}/>
                <a href="https://beian.mps.gov.cn/#/query/webSearch?code=44040202001517"
                  target="_blank" rel="noreferrer">
                  粤公网安备44040202001517号
                </a>
              </div>
              <div className='mt-3'>
                <a href="https://beian.miit.gov.cn/" 
                  target="_blank" rel="noopener noreferrer">
                  粤ICP备2023131992号
                </a>
              </div>
              <div className='mt-2'>
                <Button variant="link" className='px-0'
                  onClick={()=>handleToAgree(lg+'0')}
                >{langList.menubar14[lg]}</Button>
              </div>
              <div className='mt-2'>
                <Button variant="link" className='px-0'
                  onClick={()=>handleToAgree(lg+'1')}
                >{langList.menubar15[lg]}</Button>
              </div>
              <div className='mt-3'>
                {langList.menubar16[lg]}25982615@qq.com
              </div>
            </Accordion.Body>
          </Accordion.Item>
          <DownloadButton/>
          {role==='competent' && <div className='mt-5'>
          <Accordion.Item eventKey="11">
            <Accordion.Header>{langList.menubar17[lg]}</Accordion.Header>
            <Accordion.Body>
              <Usernum/>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="6">
            <Accordion.Header>{langList.menubar7[lg]}</Accordion.Header>
            <Accordion.Body>
              <Permission/>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="7">
            <Accordion.Header>{langList.menubar8[lg]}</Accordion.Header>
            <Accordion.Body>
              <Resetpwd/>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="8">
            <Accordion.Header>{langList.menubar9[lg]}</Accordion.Header>
            <Accordion.Body>
              <Screening/>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="9">
            <Accordion.Header>{langList.menubar10[lg]}</Accordion.Header>
            <Accordion.Body>
              <Crsytal/>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="10">
            <Accordion.Header>{langList.menubar11[lg]}</Accordion.Header>
            <Accordion.Body>
              <Tikuadd/>
            </Accordion.Body>
          </Accordion.Item>
          </div>}
        </Accordion>
      </Offcanvas.Body>
    </Offcanvas>
  )
};

